'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgActionCompare = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "M11 22v-2H2V4h9V2h2v20h-2Zm0-16v12H4V6h7Zm3 0h2.75V4H14v2Zm5.25-2h-1v2H20v1.75h2V4h-2.75ZM22 10.25v-1h-2v5.5h2v-4.5Zm0 7v-1h-2V18h-1.75v2H22v-2.75Zm-6.25.75H14v2h2.75v-2h-1Z", clipRule: "evenodd" })
);

module.exports = SvgActionCompare;
//# sourceMappingURL=ActionCompare.cjs.js.map
